import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bonusomat-modal__quest-games-scroll-wrap" }
const _hoisted_2 = { class: "bonusomat-modal__quest-games" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "bonusomat-board__modal__game__img bonusomat-board__modal__game__img--no-icon"
}

import { computed } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import useBonusomatData from "../../composables/use-bonusomat-data";
import { BonusomatQuestTask, BonusomatQuestGame } from "../../models/bonusomat-quest-detail";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-quest-detail-games',
  props: {
    task: {},
    questName: {}
  },
  emits: ["closeModal"],
  setup(__props: any, { emit: __emit }) {

const { gamesData, openGame } = useBonusomatData();

const emit = __emit;

const props = __props;

BonusomatDatalayer.pushImpressQuestGames(`${props.questName};${props.task.title}`);

const openGameClick = async (game: BonusomatQuestGame, gameIndex: number) => {
    openGame(game.id, game.type);

    BonusomatDatalayer.pushOpenQuestGame(props.task.title, gameIndex + 1);

    emit("closeModal");
};

const activeTaskGames = computed(() => gamesData.value.filter((game) => props.task.games?.includes(game.id)));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeTaskGames.value, (game, gameIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "bonusomat-board__modal__game",
          key: game.id,
          onClick: ($event: any) => (openGameClick(game, gameIndex))
        }, [
          (game.icon)
            ? (_openBlock(), _createBlock(WebpImage, {
                key: 0,
                src: game.icon,
                alt: `Ikona hry ${game.name}`,
                "css-class": "bonusomat-board__modal__game__img"
              }, null, 8, ["src", "alt"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4)),
          _createTextVNode(" " + _toDisplayString(game.name), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})